import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NewUserRequest } from '../model/newUserRequest';
import { Subscription } from 'rxjs';
import { UserService } from '../service/user.service';
import { ActivatedRoute } from '@angular/router';
import { Log } from '../util/log';
import { AliasOwnerRel } from '../model/AliasOwnerRel';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';
import { FormHelper } from '../util/formHelper';
import { AppComponent } from '../app.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from '@angular/material/dialog';
import { UploadedFile } from '../model/UploadedFile';
import { DateHelper } from '../util/dateHelper';
import { NewUserRequestPermissionType } from '../model/NewUserRequestPermissionType';


@Component({
  selector: 'app-join',
  templateUrl: './join.component.html',
  styleUrls: ['./join.component.css']
})
export class JoinComponent implements OnInit {

  @ViewChild('joinloader', { static: true }) joinloader;

  requestTypesList: NewUserRequestPermissionType[] = [];;
  genericRequestTypes = $localize`:@@join_generic_request:Generico`;


  phoneUtil = PhoneNumberUtil.getInstance();

  fileMaxSize = 3 * 1024 * 1024; // 3 MB


  // Dynamic selected files keyed by the file definition name from permissionType.fileNames
  selectedFiles: { [key: string]: { fileName: string | null, fileExt: string | null, contentType: string | null, fileData: string | null } } = {};


  errorFileSizeString = $localize`:@@join_error_file_size:Il file caricato supera la dimensione massima di 3MB`;
  errorFileFormatString = $localize`:@@join_error_file_type:Il file caricato non è in un formato accettato. Sono accettati i seguenti formati: .jpg .jpeg .png .bmp .pdf .doc .docx`;

  ownerUid: string;
  ownerName: string;

  language: string;

  fromFormControl: FormControl;
  toFormControl: FormControl;

  startDate: string;
  expirationDate: string;

  startDateDate: Date;
  expirationDateDate: Date;

  startDateString: String = "";
  expirationDateString: String = "";

  // 0wXLXGn4luWZs2mW1YMpTuGqxbH2

  aliasUid: string;
  aliases: AliasOwnerRel[];

  joinForm = new FormGroup({
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    email: new FormControl(''),
    licensePlate: new FormControl(''),
    prefix: new FormControl(''),
    phoneNumber: new FormControl(''),
    operator: new FormControl(''),
    type: new FormControl(''),
    notes: new FormControl(''),
  });


  firstname: string = "";
  lastname: string = "";

  operator: AliasOwnerRel;

  permissionType: NewUserRequestPermissionType;

  email: string = "";

  licensePlate: string = "";

  phoneNumber: string = "";
  prefix: string = "";

  notes: string = "";

  accepted: boolean = false;

  prefixes: Array<any> = [ //numeri contenenti i trattini rimossi per problemi di parsing
    { value: "+93", text: "Afghanistan +93" },
    { value: "+355", text: "Albania +355" },
    { value: "+213", text: "Algeria +213" },
    // { value: "+1-684", text: "American Samoa +1-684" },
    { value: "+376", text: "Andorra +376" },
    { value: "+244", text: "Angola +244" },
    { value: "+1-264", text: "Anguilla +1-264" },
    { value: "+672", text: "Antarctica +672" },
    { value: "+1-268", text: "Antigua +1-268" },
    { value: "+54", text: "Argentina +54" },
    { value: "+374", text: "Armenia +374" },
    { value: "+297", text: "Aruba +297" },
    { value: "+247", text: "Ascension +247" },
    { value: "+61", text: "Australia +61" },
    { value: "+672", text: "Australian Ext. Territories +672" },
    { value: "+43", text: "Austria +43" },
    { value: "+994", text: "Azerbaijan +994" },
    // // { value: "+1-242", text: "Bahamas +1-242" },
    { value: "+973", text: "Bahrain +973" },
    { value: "+880", text: "Bangladesh +880" },
    // // { value: "+1-246", text: "Barbados +1-246" },
    // // { value: "+1-268", text: "Barbuda +1-268" },
    { value: "+375", text: "Belarus +375" },
    { value: "+32", text: "Belgium +32" },
    { value: "+501", text: "Belize +501" },
    { value: "+229", text: "Benin +229" },
    // // { value: "+1-441", text: "Bermuda +1-441" },
    { value: "+975", text: "Bhutan +975" },
    { value: "+591", text: "Bolivia +591" },
    { value: "+387", text: "Bosnia & Herzegovina +387" },
    { value: "+267", text: "Botswana +267" },
    { value: "+55", text: "Brazil +55" },
    // // { value: "+1-284", text: "British Virgin Islands +1-284" },
    { value: "+673", text: "Brunei Darussalam +673" },
    { value: "+359", text: "Bulgaria +359" },
    { value: "+226", text: "Burkina Faso +226" },
    { value: "+257", text: "Burundi +257" },
    { value: "+855", text: "Cambodia +855" },
    { value: "+237", text: "Cameroon +237" },
    { value: "+1", text: "Canada +1" },
    { value: "+238", text: "Cape Verde Islands +238" },
    // // { value: "+1-345", text: "Cayman Islands +1-345" },
    { value: "+236", text: "Central African Republic +236" },
    { value: "+235", text: "Chad +235" },
    { value: "+64", text: "Chatham Island (NZ) +64" },
    { value: "+56", text: "Chile +56" },
    { value: "+86", text: "China (PRC) +86" },
    // // { value: "+61-8", text: "Christmas Island +61-8" },
    // { value: "+61", text: "Cocos-Keeling Islands +61" },
    { value: "+57", text: "Colombia +57" },
    { value: "+269", text: "Comoros +269" },
    { value: "+242", text: "Congo +242" },
    { value: "+243", text: "Congo, Dem. Rep. of +243" },
    { value: "+682", text: "Cook Islands +682" },
    { value: "+506", text: "Costa Rica +506" },
    { value: "+225", text: "Côte d'Ivoire (Ivory Coast) +225" },
    { value: "+385", text: "Croatia +385" },
    { value: "+53", text: "Cuba +53" },
    { value: "+5399", text: "Cuba (Guantanamo Bay) +5399" },
    { value: "+599", text: "Curaçao +599" },
    { value: "+357", text: "Cyprus +357" },
    { value: "+420", text: "Czech Republic +420" },
    { value: "+45", text: "Denmark +45" },
    { value: "+246", text: "Diego Garcia +246" },
    { value: "+253", text: "Djibouti +253" },
    // // { value: "+1-767", text: "Dominica +1-767" },
    // // { value: "+1-809", text: "Dominican Republic +1-809" },
    { value: "+670", text: "East Timor +670" },
    { value: "+56", text: "Easter Island +56" },
    { value: "+593", text: "Ecuador +593" },
    { value: "+20", text: "Egypt +20" },
    { value: "+503", text: "El Salvador +503" },
    { value: "+240", text: "Equatorial Guinea +240" },
    { value: "+291", text: "Eritrea +291" },
    { value: "+372", text: "Estonia +372" },
    { value: "+251", text: "Ethiopia +251" },
    { value: "+500", text: "Falkland Islands (Malvinas) +500" },
    { value: "+298", text: "Faroe Islands +298" },
    { value: "+679", text: "Fiji Islands +679" },
    { value: "+358", text: "Finland +358" },
    { value: "+33", text: "France +33" },
    { value: "+596", text: "French Antilles +596" },
    { value: "+594", text: "French Guiana +594" },
    { value: "+689", text: "French Polynesia +689" },
    { value: "+241", text: "Gabonese Republic +241" },
    { value: "+220", text: "Gambia +220" },
    { value: "+995", text: "Georgia +995" },
    { value: "+49", text: "Germany +49" },
    { value: "+233", text: "Ghana +233" },
    { value: "+350", text: "Gibraltar +350" },
    { value: "+30", text: "Greece +30" },
    { value: "+299", text: "Greenland +299" },
    // // { value: "+1-473", text: "Grenada +1-473" },
    { value: "+590", text: "Guadeloupe +590" },
    // // { value: "+1-671", text: "Guam +1-671" },
    { value: "+5399", text: "Guantanamo Bay +5399" },
    { value: "+502", text: "Guatemala +502" },
    { value: "+245", text: "Guinea-Bissau +245" },
    { value: "+224", text: "Guinea +224" },
    { value: "+592", text: "Guyana +592" },
    { value: "+509", text: "Haiti +509" },
    { value: "+504", text: "Honduras +504" },
    { value: "+852", text: "Hong Kong +852" },
    { value: "+36", text: "Hungary +36" },
    { value: "+354", text: "Iceland +354" },
    { value: "+91", text: "India +91" },
    { value: "+62", text: "Indonesia +62" },
    { value: "+98", text: "Iran +98" },
    { value: "+964", text: "Iraq +964" },
    { value: "+353", text: "Ireland +353" },
    { value: "+972", text: "Israel +972" },
    { value: "+39", text: "Italy +39" },
    // // { value: "+1-876", text: "Jamaica +1-876" },
    { value: "+81", text: "Japan +81" },
    { value: "+962", text: "Jordan +962" },
    { value: "+7", text: "Kazakhstan +7" },
    { value: "+254", text: "Kenya +254" },
    { value: "+686", text: "Kiribati +686" },
    { value: "+850", text: "Korea (North) +850" },
    { value: "+82", text: "Korea (South) +82" },
    { value: "+965", text: "Kuwait +965" },
    { value: "+996", text: "Kyrgyz Republic +996" },
    { value: "+856", text: "Laos +856" },
    { value: "+371", text: "Latvia +371" },
    { value: "+961", text: "Lebanon +961" },
    { value: "+266", text: "Lesotho +266" },
    { value: "+231", text: "Liberia +231" },
    { value: "+218", text: "Libya +218" },
    { value: "+423", text: "Liechtenstein +423" },
    { value: "+370", text: "Lithuania +370" },
    { value: "+352", text: "Luxembourg +352" },
    { value: "+853", text: "Macao +853" },
    { value: "+389", text: "Macedonia +389" },
    { value: "+261", text: "Madagascar +261" },
    { value: "+265", text: "Malawi +265" },
    { value: "+60", text: "Malaysia +60" },
    { value: "+960", text: "Maldives +960" },
    { value: "+223", text: "Mali Republic +223" },
    { value: "+356", text: "Malta +356" },
    { value: "+692", text: "Marshall Islands +692" },
    { value: "+596", text: "Martinique +596" },
    { value: "+222", text: "Mauritania +222" },
    { value: "+230", text: "Mauritius +230" },
    { value: "+269", text: "Mayotte Island +269" },
    { value: "+52", text: "Mexico +52" },
    { value: "+691", text: "Micronesia +691" },
    // // { value: "+1-808", text: "Midway Island +1-808" },
    { value: "+373", text: "Moldova +373" },
    { value: "+377", text: "Monaco +377" },
    { value: "+976", text: "Mongolia +976" },
    { value: "+382", text: "Montenegro +382" },
    // // { value: "+1-664", text: "Montserrat +1-664" },
    { value: "+212", text: "Morocco +212" },
    { value: "+258", text: "Mozambique +258" },
    { value: "+95", text: "Myanmar +95" },
    { value: "+264", text: "Namibia +264" },
    { value: "+674", text: "Nauru +674" },
    { value: "+977", text: "Nepal +977" },
    { value: "+31", text: "Netherlands +31" },
    { value: "+599", text: "Netherlands Antilles +599" },
    // // { value: "+1-869", text: "Nevis +1-869" },
    { value: "+687", text: "New Caledonia +687" },
    { value: "+64", text: "New Zealand +64" },
    { value: "+505", text: "Nicaragua +505" },
    { value: "+227", text: "Niger +227" },
    { value: "+234", text: "Nigeria +234" },
    { value: "+683", text: "Niue +683" },
    { value: "+672", text: "Norfolk Island +672" },
    // // { value: "+1-670", text: "Northern Marianas Isl. +1-670" },
    { value: "+47", text: "Norway +47" },
    { value: "+968", text: "Oman +968" },
    { value: "+92", text: "Pakistan +92" },
    { value: "+680", text: "Palau +680" },
    { value: "+970", text: "Palestinian Settlements +970" },
    { value: "+507", text: "Panama +507" },
    { value: "+675", text: "Papua New Guinea +675" },
    { value: "+595", text: "Paraguay +595" },
    { value: "+51", text: "Peru +51" },
    { value: "+63", text: "Philippines +63" },
    { value: "+48", text: "Poland +48" },
    { value: "+351", text: "Portugal +351" },
    // // { value: "+1-787", text: "Puerto Rico +1-787" },
    { value: "+974", text: "Qatar +974" },
    { value: "+262", text: "Réunion Island +262" },
    { value: "+40", text: "Romania +40" },
    { value: "+7", text: "Russia +7" },
    { value: "+250", text: "Rwandese Republic +250" },
    { value: "+290", text: "St. Helena +290" },
    // // { value: "+1-869", text: "St. Kitts/Nevis +1-869" },
    // // { value: "+1-758", text: "St. Lucia +1-758" },
    { value: "+508", text: "St. Pierre & Miquelon +508" },
    // // { value: "+1-784", text: "St. Vincent & Grenadines +1-784" },
    { value: "+685", text: "Samoa +685" },
    { value: "+378", text: "San Marino +378" },
    { value: "+239", text: "São Tomé and Principe +239" },
    { value: "+966", text: "Saudi Arabia +966" },
    { value: "+221", text: "Senegal +221" },
    { value: "+381", text: "Serbia +381" },
    { value: "+248", text: "Seychelles Republic +248" },
    { value: "+232", text: "Sierra Leone +232" },
    { value: "+65", text: "Singapore +65" },
    { value: "+421", text: "Slovak Republic +421" },
    { value: "+386", text: "Slovenia +386" },
    { value: "+677", text: "Solomon Islands +677" },
    { value: "+252", text: "Somali Democratic Republic +252" },
    { value: "+27", text: "South Africa +27" },
    { value: "+34", text: "Spain +34" },
    { value: "+94", text: "Sri Lanka +94" },
    { value: "+249", text: "Sudan +249" },
    { value: "+597", text: "Suriname +597" },
    { value: "+268", text: "Swaziland +268" },
    { value: "+46", text: "Sweden +46" },
    { value: "+41", text: "Switzerland +41" },
    { value: "+963", text: "Syria +963" },
    { value: "+886", text: "Taiwan +886" },
    { value: "+992", text: "Tajikistan +992" },
    { value: "+255", text: "Tanzania +255" },
    { value: "+66", text: "Thailand +66" },
    { value: "+670", text: "Timor Leste +670" },
    { value: "+228", text: "Togolese Republic +228" },
    { value: "+690", text: "Tokelau +690" },
    { value: "+676", text: "Tonga Islands +676" },
    // // { value: "+1-868", text: "Trinidad & Tobago +1-868" },
    { value: "+216", text: "Tunisia +216" },
    { value: "+90", text: "Turkey +90" },
    { value: "+993", text: "Turkmenistan +993" },
    // // { value: "+1-649", text: "Turks and Caicos Islands +1-649" },
    { value: "+688", text: "Tuvalu +688" },
    { value: "+256", text: "Uganda +256" },
    { value: "+380", text: "Ukraine +380" },
    { value: "+971", text: "United Arab Emirates +971" },
    { value: "+44", text: "United Kingdom +44" },
    { value: "+1", text: "United States of America +1" },
    // // { value: "+1-340", text: "US Virgin Islands +1-340" },
    { value: "+598", text: "Uruguay +598" },
    { value: "+998", text: "Uzbekistan +998" },
    { value: "+678", text: "Vanuatu +678" },
    { value: "+379", text: "Vatican City +379" },
    { value: "+58", text: "Venezuela +58" },
    { value: "+84", text: "Vietnam +84" },
    { value: "+808", text: "Wake Island +808" },
    { value: "+681", text: "Wallis and Futuna Isl. +681" },
    { value: "+967", text: "Yemen +967" },
    { value: "+260", text: "Zambia +260" },
    { value: "+255", text: "Zanzibar +255" },
    { value: "+263", text: "Zimbabwe +263" }
  ];

  newUserRequest: NewUserRequest;

  createNewUserRequestSubscription: Subscription;

  showRequestForm: boolean = false;
  requestCreated: boolean = false;
  requestCreationError: boolean = false;
  invalidOwnerUid: boolean = false;

  wrongPhoneNumberError: boolean = false;
  firstnameError: boolean = false;
  lastnameError: boolean = false;
  emailError: boolean = false;
  licencePlateError: boolean = false;
  notesError: boolean = false;
  missingFileError: boolean = false;

  invalidDatesError: boolean = false;
  dateOver2100Error: boolean = false;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private appComponent: AppComponent,
    private overlay: Overlay,
    public dialog: MatDialog,


  ) { }

  ngOnInit(): void {
    let oneMonthDate = new Date();
    oneMonthDate.setMonth(oneMonthDate.getMonth() + 1);

    this.startDate = DateHelper.formatDateRFC3339(new Date());

    this.expirationDate =
      DateHelper.formatDateRFC3339(oneMonthDate);

    this.fromFormControl = new FormControl(this.startDate);
    this.toFormControl = new FormControl(this.expirationDate);


    // this.appComponent.logoutSilent();
  }


  ngAfterViewInit() {
    this.ownerUid = this.route.snapshot.paramMap.get('ownerUid');
    Log.debug(this.ownerUid);

    if (this.ownerUid.length < 10) {
      Log.debug("this.ownerUid is too short");
      this.invalidOwnerUid = true;
    } else {

      setTimeout(() => {
        this.getOwnerTypes();
      }, 100);

      setTimeout(() => {
        this.getAliases();
      }, 300);

      this.language = this.appComponent.getCurrentLanguage().toLowerCase();

      setTimeout(() => {
        this.joinloader.hideLoading();
      }, 1000);
    }

  }

  ngOnDestroy(): void {
    if (this.createNewUserRequestSubscription) {
      this.createNewUserRequestSubscription.unsubscribe();
    }
  }

  getAliases() {
    const obs = this.userService.getAvailableOperators(this.ownerUid);
    obs.subscribe(data => {

      Log.debug("\n\ndata:");
      Log.debug(data);

      if (data.length == 0) {
        this.showRequestForm = false;
        this.invalidOwnerUid = true;
      } else {

        this.aliases = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].availableFeature.includes("show-inlist") || data[i].availableFeature.includes("All")) {
            this.aliases.push(data[i]);
          }
        }

        this.operator = this.aliases[0];
        this.ownerName = this.aliases[0].owner.displayName;
        this.showRequestForm = true;
      }

    }, error => {

      Log.debug(error);

      this.showRequestForm = false;
      this.invalidOwnerUid = true;

      this.joinloader.showError();
    });
  }


  getOwnerTypes() {

    this.userService.getNewUserRequestPermissionTypePublic(this.ownerUid).subscribe((response) => {
      Log.debug(response);

      // Se il gestore non ha creato tipi di permesso inserisco un permesso generico senza file richiesti
      if (response.length == 0) {
        let genericRequestType = new NewUserRequestPermissionType();
        genericRequestType.name = this.genericRequestTypes;
        genericRequestType.fileNames = [];
        this.requestTypesList.push(genericRequestType);
        this.permissionType = this.requestTypesList[0];
      } else {
        this.requestTypesList = response;
        this.permissionType = this.requestTypesList[0];
      }

      // initialize selectedFiles for the default selected permission type
      this.initializeSelectedFiles();
    }, (err) => {
      Log.debug(err);
      this.joinloader.showError();
    });

  }

  permissionTypeSelected(event: any) {
    this.joinloader.showLoading();


    Log.debug("Selected permission type:");
    Log.debug(event);
    Log.debug(this.permissionType);

    // initialize selectedFiles structure for the selected permission type
    this.initializeSelectedFiles();

    setTimeout(() => {
      this.joinloader.hideLoading();
    }, 500);

  }

  operatorSelected(event: any) {
    this.joinloader.showLoading();


    Log.debug("Selected operator:");
    Log.debug(event);
    Log.debug(this.operator);

    setTimeout(() => {
      this.joinloader.hideLoading();
    }, 300);
  }

  private initializeSelectedFiles(): void {
    this.selectedFiles = {};
    if (this.permissionType && Array.isArray(this.permissionType.fileNames)) {
      for (const fname of this.permissionType.fileNames) {
        this.selectedFiles[fname] = { fileName: null, fileExt: null, contentType: null, fileData: null };
      }
    }
  }

  phoneNumberCheck() {
    try {
      let numberToCheck = this.phoneUtil.parse(this.prefix + this.phoneNumber.replace(/\D/g, ''));

      if (this.phoneUtil.isValidNumber(numberToCheck)) {
        Log.debug("Number is OK");
        return true;
      } else {
        Log.debug("Number is NOT OK");

        this.wrongPhoneNumberError = true;
        return false;
      }
    } catch (e: unknown) {
      Log.debug("Number is NOT OK");
      Log.debug(e);
      this.wrongPhoneNumberError = true;
      return false;
    }
  }

  createRequest() {

    this.wrongPhoneNumberError = false;
    this.firstnameError = false;
    this.lastnameError = false;
    this.emailError = false;
    this.licencePlateError = false;
    this.notesError = false;
    this.missingFileError = false;
    this.invalidDatesError = false;
    this.dateOver2100Error = false;


    if (this.firstname.length < 3) {
      Log.debug("firstnameError");
      this.firstnameError = true;
      return;
    }

    if (this.lastname.length < 3) {
      Log.debug("lastnameError");
      this.lastnameError = true;
      return;

    }

    if (!FormHelper.isValidEmail(this.email)) {
      Log.debug("emailError");
      this.emailError = true;
      return;

    }

    if (this.licensePlate.length < 3) {
      Log.debug("licencePlateError");
      this.licencePlateError = true;
      return;
    }

    if (!this.phoneNumberCheck()) {
      Log.debug("wrongPhoneNumberError");
      this.wrongPhoneNumberError = true;
      return;
    }

    // Check that all required files for the selected permissionType are present
    if (this.permissionType && Array.isArray(this.permissionType.fileNames) && this.permissionType.fileNames.length > 0) {
      for (const fname of this.permissionType.fileNames) {
        const sel = this.selectedFiles[fname];
        if (!sel || !sel.fileData) {
          Log.debug(`File richiesto mancante: ${fname}`);
          this.missingFileError = true;
          return;
        }
      }
    }


    let from: Date;
    from = new Date(this.fromFormControl.value);
    from.setHours(0);
    from.setMinutes(0);
    from.setSeconds(0);
    from.setMilliseconds(0);

    let to: Date;
    to = new Date(this.toFormControl.value);
    to.setHours(23);
    to.setMinutes(59);
    to.setSeconds(59);
    to.setMilliseconds(0);

    this.startDate = DateHelper.formatDateRFC3339(from);
    this.expirationDate = DateHelper.formatDateRFC3339(to);
    this.startDateDate = from;
    this.expirationDateDate = to;

    if (from >= to || to <= new Date()) {
      Log.debug("dates error");
      this.invalidDatesError = true;
      return false;
    }

    Log.debug(to.getFullYear());

    if (to.getFullYear() > 2100) {
      this.dateOver2100Error = true;
      return false;
    }

    if (this.notes.length < 3) {
      Log.debug("notesError");
      this.notesError = true;
      return;
    }

    this.joinloader.showLoading();

    this.newUserRequest = new NewUserRequest();
    this.newUserRequest.firstname = this.firstname;
    this.newUserRequest.lastname = this.lastname;
    this.newUserRequest.email = this.email;
    this.newUserRequest.licensePlate = this.licensePlate;
    this.newUserRequest.prefix = this.prefix;
    this.newUserRequest.phoneNumber = this.phoneNumber;
    this.newUserRequest.notes = this.notes;
    this.newUserRequest.language = this.language;
    this.newUserRequest.accepted = this.accepted;

    this.newUserRequest.startDate = this.startDateDate;
    this.newUserRequest.expirationDate = this.expirationDateDate;

    this.newUserRequest.ownerUid = this.ownerUid;

    this.newUserRequest.files = [];

    // Attach dynamic files
    if (this.permissionType && Array.isArray(this.permissionType.fileNames)) {
      for (const fname of this.permissionType.fileNames) {
        const sel = this.selectedFiles[fname];
        if (sel && sel.fileData) {
          const f = new UploadedFile();
          f.fileName = sel.fileName;
          f.fileExt = sel.fileExt;
          f.fileData = sel.fileData;
          f.contentType = sel.contentType;
          f.description = fname; // use the provided name as description
          this.newUserRequest.files.push(f);
        }
      }
    }

    Log.debug("this.operator");
    Log.debug(this.operator);

    this.newUserRequest.aliasUid = this.operator.aliasUid;

    Log.debug("\n\nnewUserRequest: ");
    Log.debug(this.newUserRequest);


    this.createNewUserRequestSubscription = this.userService.createNewUserRequest(this.newUserRequest, this.ownerUid).subscribe((response) => {

      this.showRequestForm = false;
      this.requestCreated = true;

      this.joinloader.hideLoading();

    }, (err) => {

      Log.debug(err);
      this.showRequestForm = false;
      this.requestCreationError = true;
      this.joinloader.hideLoading();

    });

  }

  private extractFileNameAndExt(file: File): { name: string, ext: string } {
    const match = file.name.match(/^(.*)\.([^.]+)$/);
    if (match) {
      return { name: match[1], ext: match[2].toLowerCase() };
    }
    return { name: file.name, ext: '' };
  }

  onFileSelected(event: Event, fileDefName: string): void {
    const input = event.target as HTMLInputElement;
    if (!input || !input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];
    if (!this.isValidFileType(file)) {
      this.showDialog('Tipo di file non ammesso');
      input.value = '';
      if (this.selectedFiles[fileDefName]) this.selectedFiles[fileDefName].fileData = null;
      return;
    }
    if (file.size > this.fileMaxSize) {
      this.showDialog(this.errorFileSizeString);
      input.value = '';
      if (this.selectedFiles[fileDefName]) this.selectedFiles[fileDefName].fileData = null;
      return;
    }
    const { name, ext } = this.extractFileNameAndExt(file);
    if (!this.selectedFiles[fileDefName]) {
      this.selectedFiles[fileDefName] = { fileName: null, fileExt: null, contentType: null, fileData: null };
    }
    this.selectedFiles[fileDefName].fileName = name;
    this.selectedFiles[fileDefName].fileExt = ext;
    this.selectedFiles[fileDefName].contentType = file.type;

    const reader = new FileReader();
    reader.onload = () => {
      this.selectedFiles[fileDefName].fileData = (reader.result as string).split(',')[1];
    };
    reader.readAsDataURL(file);
  }


  showDialog(inputMessage) {
    let message = inputMessage;
    let header = $localize`:@@join_error:Errore`;
    // let confirmMessage = $localize`:@@groupadd_delete_group_confirm_yes: Conferma`;
    // let cancelMessage = $localize`:@@groupadd_delete_group_confirm_no: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: { message, header },
      // , confirmMessage, cancelMessage 
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
      }
    });
  }

  isValidFileType(file: File): boolean {
    // Accetta: .jpg .jpeg .png .bmp .pdf .doc .docx (case insensitive)
    const regex = /\.(jpg|jpeg|png|bmp|pdf|docx?|)$/i;
    return regex.test(file.name);
  }
}